// store/modules/taxonomyFrontend.js
const FUNCTION_URL = "https://data-reviewer-mongo-998838505944.europe-west6.run.app";

const KEYS_TO_SKIP = ["name","url","total_items","attribute_ids","filters","subcategories","sources"];

function createItemFromData(data, itemId) {
  if (!data || typeof data !== "object") return null;
  const label = data.name || itemId || "New Node";

  // The same logic you use in the main code:
  const nodeFilters = Array.isArray(data.attribute_ids)
    ? data.attribute_ids
    : Array.isArray(data.filters)
      ? data.filters
      : [];

  const item = {
    id: itemId,
    label,
    children: [],
    filters: nodeFilters,
  };

  if (item.filters.length > 0) {
    item.style = { background: "#108ffe", color: "#fff" };
  }

  if (Array.isArray(data.subcategories)) {
    data.subcategories.forEach((sub, idx) => {
      const childId = `${itemId}.[${idx}]`;
      const childItem = createItemFromData(sub, childId);
      if (childItem) item.children.push(childItem);
    });
  } else {
    const keys = Object.keys(data).filter(
      (k) => !KEYS_TO_SKIP.includes(k)
    );
    keys.forEach((k) => {
      const childId = `${itemId}.${k}`;
      const childData = data[k];
      if (childData && typeof childData === "object") {
        const childItem = createItemFromData(childData, childId);
        if (childItem) {
          item.children.push(childItem);
        }
      }
    });
  }
  return item;
}

function convertToTreeItems(data, parentId="root") {
  if (!data || typeof data !== "object") {
    const label = (data && data.name) || parentId || "New Node";
    return [{ id: parentId, label, children: [], filters: [] }];
  }
  const itemId = parentId || "root";
  const label = data.name || itemId || "New Node";
  const rootNode = {
    id: itemId,
    label,
    children: [],
    filters: Array.isArray(data.attribute_ids) ? data.attribute_ids : [],
  };
  if (rootNode.filters.length > 0) {
    rootNode.style = { background: "#108ffe", color: "#fff" };
  }

  if (Array.isArray(data.subcategories)) {
    data.subcategories.forEach((sub, index) => {
      const subId = `${itemId}.[${index}]`;
      const subItem = createItemFromData(sub, subId);
      if (subItem) rootNode.children.push(subItem);
    });
  } else {
    const keys = Object.keys(data).filter(
      (k) => !KEYS_TO_SKIP.includes(k)
    );
    keys.forEach((k) => {
      const childId = `${itemId}.${k}`;
      const childData = data[k];
      if (childData && typeof childData === "object") {
        const childItem = createItemFromData(childData, childId);
        if (childItem) {
          rootNode.children.push(childItem);
        }
      }
    });
  }

  return [rootNode];
}

export default {
  namespaced: true,
  state: () => ({
    // This is what you reference in `frontendOrgData()`
    treeItems: [],
    // If you have metadata, or other data for the "frontend" taxonomy
    // you can add them here too.
  }),
  mutations: {
    setTreeItems(state, payload) {
      state.treeItems = payload;
    },
  },
  actions: {
    /**
     * Example "load" action that fetches from your serverless function
     * that knows how to read from the Mongo collection "taxonomy_frontend".
     */
    async loadTaxonomyDataFromMongo({ commit, rootState }) {
      try {
        const rawVersion = rootState.ui.selectedVersion || "Working Version";
        const safeVersion = encodeURIComponent(rawVersion);
        const path = `allium-ai-manor/taxonomies/frontend_modified_${safeVersion}.json`;
        const url = `https://data-reviewer-mongo-998838505944.europe-west6.run.app?action=load&path=${path}`;
        
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status} - ${response.statusText}`);
        }
        
        const json = await response.json();
        console.log("[taxonomyFrontend] loadTaxonomyDataFromMongo response:", json);

        // Your doc might look like { data: {...the entire object...}, metadata: {...} }
        if (json && json.data) {
          // Now replicate the same approach used in main code:
          // Convert doc.data into the tree array
          const mainTree = convertToTreeItems(json.data, "root");
          // Then commit that array
          commit('setTreeItems', mainTree);
        } else {
          console.log("Couldn't build items for frontend taxonomy");
          commit('setTreeItems', []);
        }
      } catch (err) {
        console.error('Error loading taxonomy_frontend:', err);
        commit('setTreeItems', []);
      }
    },

    /**
     * Example "save" action if you want to persist changes back
     * to the "taxonomy_frontend" collection in Mongo.
     */
    async saveTaxonomyDataToMongo({ state }) {
      try {
        const payload = { treeItems: state.treeItems };
        const url = `${FUNCTION_URL}?action=save`;
        const response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        if (!response.ok) {
          throw new Error(`HTTP ${response.status} - ${response.statusText}`);
        }
        const result = await response.json();
        console.log('Saved taxonomy_frontend:', result);
        // success toast or UI feedback
      } catch (err) {
        console.error('Error saving taxonomy_frontend:', err);
        // show error toast or do something else
      }
    },
  },
};
